import { render, staticRenderFns } from "./PlayerDetailsForm.vue?vue&type=template&id=3d8ff658&"
import script from "./PlayerDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./PlayerDetailsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports